import { AfterViewInit, Component, Inject, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core'
import _ from 'lodash'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { PerfectScrollbarActions } from '../../../shared/ui/perfect-scrollbar/state/actions-type'

@Component({
    selector: 'ca-perfect-scrollbar',
    template: '<div class="scrollable ps-container" [id]="this.id"><ng-content></ng-content></div>',
})
export class PerfectScrollbarComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @Input() key: string // unique key to identify component instance
    @Input() featureKey: string // unique key to identify feature instance - should reflect origin component storeFeatureKey
    @Input() componentKey: string // key for nested component of TOP level feature - we can have multiple PS on same feature
    @Input() idSuffix: string // optional suffix of the DOM id only; lets two instances that share featureKey (e.g. a page filter and
    // the same search in a dialog) have distinct DOM containers. Does NOT affect store keys or targetKey.
    @Input() isVisible: boolean // visibility flag
    @Input() initialLoad: boolean // load initial data with empty filterCriteria?
    @Input() isSearchComponent: boolean // set special behavior for elements using search text input
    @Input() globalStatePath: string // optional binding - redux store identifier; if not defined the `key` binding value is used as path

    @Input() reducerKey: string // optional binding - unique identifier of object within a map in reducer, if not defined
    // the desired object is accessed directly (i.e. const elem = $ngRedux.getState()[globalStatePath].filterCriteria).
    // If reducerKey is defined it works as in the following example:

    /*  function sampleReducer(...) {
            ...
            return ReduxUtilsService.createReducer({
                mapOfElements: {}
            }, actions);

            ...
        }

        -- and then if we want to retrieve some element:

        const elem = $ngRedux.getState()[globalStatePath].mapOfElements[reducerKey]
     */

    // -- function bindings (expected arguments listed in parentheses)
    @Input() loadAction: ((any) => Promise<any>) | ((any) => Observable<any>) // function returning promise or observable
    @Input() itemCollectionAction: any // (array of objects)
    @Input() filterCriteriaAction: any // (object with set of properties:values pairs),

    public id: string

    constructor(
        @Inject(Store) private store: Store,
        @Inject(NgZone) protected ngZone: NgZone) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        Object.entries(changes).forEach(([key, value]) => {
            if (_.isEqual(value.currentValue, value.previousValue)) {
                return
            }

            switch (key) {
                case 'isVisible':
                    if (this.featureKey) {
                        this.store.dispatch(PerfectScrollbarActions.visibleChange({ key: this.featureKey, isVisible: value.currentValue, psSelector: this.id }))
                    } else {
                        throw new Error('featureKey missing form ca-perfect-scrollbar ngOnChanges')
                    }
                    break
            }
        })
    }

    ngOnDestroy(): void {
        this.ngZone.run(() => {
            this.store.dispatch(PerfectScrollbarActions.reset({ key: this.featureKey }))
        })
    }

    ngOnInit(): void {
        const key = this.globalStatePath ?? this.featureKey
        this.id =  'ps-' + key + (this.componentKey ? `-${ this.componentKey }` : '') + (this.idSuffix ? `-${ this.idSuffix }` : '')
    }

    ngAfterViewInit(): void {
        this.store.dispatch(PerfectScrollbarActions.init({
            key: this.featureKey,
            psSelector: this.id,
            globalStatePath: this.globalStatePath,
            targetKey: this.componentKey,
            reducerKey: this.reducerKey,
            isVisible: this.isVisible,
            initialLoad: this.initialLoad === true,
            isSearchComponent: this.isSearchComponent === true,
        }))
    }

}